<div class="relative h-screen bg-gradient-to-br from-gray-50 to-gray-200 dark:from-gray-900 dark:to-gray-800 text-gray-800 dark:text-gray-100">

  <nav class="fixed w-full z-50 transition-all duration-300 bg-white/80 dark:bg-gray-900/80 h-20 backdrop-blur-sm shadow-md shadow-slate-100 dark:shadow-gray-900/30"
       aria-label="Main Navigation">
    <div class="!max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full">
      <div class="flex items-center justify-between h-full">
        <div class="flex-shrink-0 flex items-center space-x-2 cursor-pointer outline-none rounded-lg focus-visible:ring-2 focus-visible:ring-primary-400">

            <span class="font-extrabold text-3xl flex gap-2 items-center text-primary-900 dark:text-primary-400 border border-dotted dark:border-gray-600 p-3 rounded-xl">
              <img src="assets/images/emblem.png" class="w-6 md:w-8" alt="">
            </span>

        </div>

        <div class="block">
          <div class="ml-10 flex items-center space-x-8">

            <!-- Theme Switcher -->
            <label class="switch scale-90">
              @if (!isLightMode) {
              <span class="sun"
                ><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <g fill="#C99900">
                    <circle cx="12" cy="12" r="5"></circle>
                    <path
                      d="m21 13h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2zm-17 0h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2zm13.66-5.66a1 1 0 0 1 -.66-.29 1 1 0 0 1 0-1.41l.71-.71a1 1 0 1 1 1.41 1.41l-.71.71a1 1 0 0 1 -.75.29zm-12.02 12.02a1 1 0 0 1 -.71-.29 1 1 0 0 1 0-1.41l.71-.66a1 1 0 0 1 1.41 1.41l-.71.71a1 1 0 0 1 -.7.24zm6.36-14.36a1 1 0 0 1 -1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1 -1 1zm0 17a1 1 0 0 1 -1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1 -1 1zm-5.66-14.66a1 1 0 0 1 -.7-.29l-.71-.71a1 1 0 0 1 1.41-1.41l.71.71a1 1 0 0 1 0 1.41 1 1 0 0 1 -.71.29zm12.02 12.02a1 1 0 0 1 -.7-.29l-.66-.71a1 1 0 0 1 1.36-1.36l.71.71a1 1 0 0 1 0 1.41 1 1 0 0 1 -.71.24z"
                    ></path>
                  </g></svg
              ></span>
              }
              @if (isLightMode) {
              <span class="moon"
                ><svg viewBox="0 0 384 512" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="m223.5 32c-123.5 0-223.5 100.3-223.5 224s100 224 223.5 224c60.6 0 115.5-24.2 155.8-63.4 5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6-96.9 0-175.5-78.8-175.5-176 0-65.8 36-123.1 89.3-153.3 6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"
                  ></path></svg
              ></span>
              }
              <input
                (ngModelChange)="toggleTheme()"
                [(ngModel)]="isLightMode"
                class="input"
                type="checkbox"
              />
              <span class="slider"></span>
            </label>

            <button [routerLink]="['']" class="ml-4 flex items-center justify-center gap-2 px-6 py-2.5 rounded-full text-sm font-bold transition-all transform
              hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary-500
              bg-primary-600 text-white hover:bg-primary shadow-xl shadow-slate-900/10">
              <div class="-mb-1"><mat-icon class="p-0 m-0">home</mat-icon></div>
              <div>Home</div>
            </button>

          </div>

        </div>

      </div>
    </div>

  </nav>

  <main id="main-content position-relative">

    <section id="top"
             class="relative overflow-hidden z-0 h-screen flex flex-col justify-center px-4 md:sticky md:top-0"
             aria-label="Hero">

      <!-- Animated Background Blobs -->
      <div class="absolute inset-0 overflow-hidden pointer-events-none z-0">
        <div
          class="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] bg-primary-100/30 rounded-full blur-[100px] animate-blob"
        ></div>
        <div
          class="absolute top-[20%] -right-[10%] w-[40%] h-[60%] bg-secondary-100/30 rounded-full blur-[100px] animate-blob animation-delay-2000"
        ></div>
        <div
          class="absolute -bottom-[20%] left-[20%] w-[50%] h-[50%] bg-accent-100/20 rounded-full blur-[100px] animate-blob animation-delay-4000"
        ></div>
      </div>


      <div class="absolute inset-x-0 top-0 h-full pointer-events-none
                bg-gradient-to-b from-white dark:from-gray-900 via-white dark:via-gray-900 to-transparent">
      </div>

      <div class="!max-w-7xl mx-auto w-full relative">

        <div class="bg-transparent min-h-screen flex items-center justify-center">
          <div class="bg-white/40 dark:bg-gray-800/40 backdrop-blur-md border border-white/40 dark:border-gray-600/40 w-full lg:w-1/3 rounded-xl md:py-7 p-5 md:px-10 flex flex-col items-center justify-center relative shadow-2xl">

            <span class="font-extrabold w-full mb-2 text-3xl flex gap-2 items-center justify-center text-primary-900 dark:text-primary-400 border border-dotted dark:border-gray-600 p-3 rounded-xl">
              <img src="assets/images/emblem.png" class="w-6 md:w-8" alt="">
              <span class="tracking-[2px]">GISP</span>
            </span>

            <div class="flex flex-col items-center text-center mb-4 justify-center gap-2 p-4 border-b border-b-slate-200 dark:border-b-gray-700 w-full">
                <span class="text-gray-dark dark:text-gray-300">Reset Password <br>
                 <b>Please enter your email address</b></span>
            </div>

            <div class="w-full">
              <form (ngSubmit)="submitForm(form.value)"
                    [formGroup]="form"
                    autocomplete="off"
                    novalidate class="w-full mt-3">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'Email Address'  }}</mat-label>
                  <input type="email" matInput formControlName="email">
                  <mat-icon matIconSuffix>email</mat-icon>
                  <mat-error>
          <span
            *ngIf="!form.get('email')?.valid && form.get('email')?.touched">
              {{ 'Field is required'  }}
          </span>
                  </mat-error>
                </mat-form-field>


                <div class="w-full mt-2 mb-3">
                  <button type="submit" [disabled]="!form.valid || loading" class="w-full" mat-raised-button color="primary">
                    {{ 'Reset Password'  }}
                  </button>
                </div>
                <div class="w-full mt-4 text-center">
                  <p class="text-md text-gray-dark dark:text-gray-300"><button type="button" (click)="goBack()" (keyup)="$event.stopPropagation()" class="text-primary dark:text-primary-400 font-bold">{{ 'Back To Log In'  }}</button></p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

    </section>

  </main>

  <app-system-footer></app-system-footer>

</div>
